<template lang="html">
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex
        v-for="rate in rates"
        :key="rate.id"
        xs12
        md6>
        <RateDialog
          v-model="valid">
          <template #activator="{ on }">
            <RateCard :rate="rate" v-on="on" @click="handle(rate)"/>
          </template>
          <template #input>
            <v-flex
              v-for="(value, propertyName) in rate"
              v-if="displayProperty(propertyName)"
              :key="propertyName"
              xs12
              md6>
              <BusieInput
              :label="fieldLabel(propertyName)"
              v-model="payload[propertyName]"
              :disabled="(value === 'Standard' || value === 'Peak') ? true : false"
              :rules="propertyName === 'name' ? nameRules : rateRules"/>
            </v-flex>
          </template>
          <template #actions="{ deactivate }">
            <BusieButton
              text="Cancel"
              color="warning"
              v-on='deactivate'/>
            <BusieButton
              text="Submit"
              v-on="deactivate"
              @click="submit"/>
          </template>
        </RateDialog>
      </v-flex>
      <v-flex
        xs12
        md6>
        <RateDialog
          title="Create Rate"
          v-model="valid">
          <template #activator=" { on } ">
            <RateCard v-on="on" @click="payload = createFreshForm()"/>
          </template>
          <template #input>
            <v-flex
              v-for="(value, propertyName) in payload"
              v-if="displayProperty(propertyName)"
              :key="propertyName"
              xs12
              md6>
              <BusieInput
                :label="fieldLabel(propertyName)"
                v-model="payload[propertyName]"
                :rules="propertyName === 'name' ? nameRules : rateRules"/>
            </v-flex>
          </template>
          <template #actions=" { deactivate } ">
            <BusieButton
              text="Cancel"
              color='warning'
              v-on="deactivate"/>
            <BusieButton
              text="Submit"
              v-on="deactivate"
              @click="submit"/>
          </template>
        </RateDialog>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import label from '@/utils/label'
import RateCard from '@/components/busie/RateCard'
import BusieInput from '@/components/busie/StandardInput'
import BusieButton from '@/components/busie/StandardButton'
import RateDialog from '@/components/busie/RateDialog'
import RulesFactory from '@/utils/validation/RulesFactory'

export default {
  components: {
    RateCard,
    RateDialog,
    BusieInput,
    BusieButton
  },
  props: {},
  data () {
    return {
      payload: this.createFreshForm(),
      valid: true,
      rateRules: RulesFactory.get('rates'),
      nameRules: RulesFactory.get('name')
    }
  },
  computed: {
    rates () {
      let rates = [this.standard, this.peak]
      this.misc.filter(r => r.saved).forEach(rate => rates.push(rate))
      return rates
    },
    querystring () {
      return `?dispatch__id=${this.location}&saved=True`
    },
    fieldLabel: () => propertyName => label(propertyName),
    displayProperty: () => propertyName => ![
      'id', 'type', 'dispatch', 'saved'].includes(propertyName),
    ...mapGetters('user', ['location']),
    ...mapGetters('rates', {
      standard: 'getStandard',
      peak: 'getPeak',
      misc: 'getMisc'
    })
  },
  mounted () {
    this.fetchAll(this.querystring).then().catch(e => this.raiseError(e))
  },
  methods: {
    submit () {
      this.payload.id
        ? this.update(this.payload).then(
          () => this.fetchAll(this.querystring)).catch(
          e => this.raiseError(e))
        : this.create(this.payload).then(
          () => this.fetchAll(this.querystring)).catch(
          e => this.raiseError(e))

      this.payload = this.createFreshForm()
    },
    handle (rate) {
      this.payload = rate
    },
    createFreshForm () {
      return {
        name: null,
        live_rate: null,
        dead_rate: null,
        type: 'm',
        dispatch: this.location,
        layover: null,
        extra_driver: null,
        misc_cost: null,
        hourly: null,
        gratituity: null,
        day_rate: null,
        leg_rate: null
      }
    },
    ...mapActions('rates', [ 'fetchAll', 'create', 'update' ]),
    ...mapActions('app', [ 'raiseError' ])
  }
}
</script>

<style lang="css" scoped>
</style>
